import { Box, Divider, Drawer, IconButton, Skeleton, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import React, { useEffect } from 'react';
import { useGetCreditNotePdf } from '../../../../hooks/use-get-credit-note-pdf';
import { PdfViewer } from '../../../../components/new-design/layout/PdfViewer/PdfViewer';

type CreditNotePdfPreviewDrawerProps = {
  open: boolean;
  onClose: () => void;
  creditLedgerId: string | null;
};

export const CreditNotePdfPreviewDrawer: React.FC<CreditNotePdfPreviewDrawerProps> = ({
  open,
  onClose,
  creditLedgerId,
}) => {
  const { mutate, data, isLoading, reset } = useGetCreditNotePdf();

  useEffect(() => {
    if (open && creditLedgerId) {
      mutate({ creditLedgerId });
    }

    return () => {
      reset();
    };
  }, [open, creditLedgerId, mutate, reset]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        width: '767px',
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: '767px',
          height: '100vh',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#ECEDEE',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: 'background.default',
          px: 3,
          py: 2,
          gap: 2,
        }}
      >
        <Typography variant="h5" sx={{
          color: "text.primary"
        }}>
          Credit note preview
        </Typography>

        <IconButton onClick={onClose}>
          <VyIcon icon="CloseBig" />
        </IconButton>
      </Box>
      <Divider />
      <Stack
        sx={{
          backgroundColor: '#ECEDEE',
          padding: '32px',
          alignItems: 'center',
          flex: 1,
          overflow: 'auto',
        }}
      >
        {isLoading ? (
          <Skeleton variant="rectangular" width="100%" height="100%" />
        ) : (
          data?.encodedPdf && <PdfViewer base64EncodedPdf={data.encodedPdf} />
        )}
      </Stack>
    </Drawer>
  );
};
